var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scrolled)?_c('div',{staticClass:"scroll-top",on:{"click":_vm.scrollToTop}},[_c('font-awesome-icon',{attrs:{"icon":"angle-up","size":"lg"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }